export default __webpack_public_path__ + "./resource/hkbn-icon.8aa6f4e3dfcf79fe38dacd2ee18460fc.woff";